module.exports = __webpack_public_path__ + "static/media/man-facepalming-svgrepo-com.02ef2b9e.svg";